import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface NearestPeriodResponse {
  periodId: number;
}

const useGetNearestPeriodApi = (invoiceId: number) => {
  const call = useCallback(
    () =>
      new Promise<NearestPeriodResponse>((resolve, reject) => {
        axiosInstance
          .get(api.getNearestPeriod(invoiceId))
          .then((data) => {
            resolve({ periodId: data.data });
          })
          .catch((error) => {
            reject(error);
          });
      }),
    [invoiceId]
  );

  const { execute, value } = useAsync(call, false);

  return {
    getNearestPoPeriod: execute,
    nearestPoPeriod: value,
  } as const;
};

export default useGetNearestPeriodApi;
